import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  DATA_URL, DEFECTS_URL,
  GO_URL, ID_PARAM, MAP_URL, NEW_ORDER_URL, ORDER_DETAILS_URL,
  ORDERS_URL,
  REPORTS_URL,
  SETTINGS_URL, TASKS_URL, UNAUTHORIZED_URL
} from './config/url.config';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { OrdersPageComponent } from './pages/orders-page/orders-page.component';
import { MapPageComponent } from './pages/map-page/map-page.component';
import {
  OrderFormComponent
} from './pages/orders-page/components/order-form/order-form.component';
import {
  AccessGuard,
  AdminGuard, DataGuard, DefectsGuard, MapGuard,
  OrdersGuard, ReportsGuard, TasksGuard
} from './guards/permission.guard';
import {
  UnauthorizedPageComponent
} from './pages/unauthorized-page/unauthorized-page.component';
import {
  OrderDetailsComponent
} from './pages/orders-page/components/order-details/order-details.component';
import {
  TasksPageComponent
} from './modules/go/pages/tasks-page/tasks-page.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AccessGuard],
    children: [
      {
        path: '',
        component: HomePageComponent
      },
      {
        path: ORDERS_URL,
        component: OrdersPageComponent,
        canActivate: [OrdersGuard]
      },
      {
        path: NEW_ORDER_URL,
        component: OrderFormComponent,
        canActivate: [OrdersGuard]
      },
      {
        path: ORDERS_URL + '/:' + ID_PARAM,
        component: OrderFormComponent,
        canActivate: [OrdersGuard]
      },
      {
        path: ORDER_DETAILS_URL + '/:' + ID_PARAM,
        component: OrderDetailsComponent,
        canActivate: [OrdersGuard]
      },
      {
        path: MAP_URL,
        component: MapPageComponent,
        canActivate: [MapGuard]
      },
      {
        path: TASKS_URL,
        component: TasksPageComponent,
        canActivate: [TasksGuard]
      },
      {
        path: DEFECTS_URL,
        loadChildren: () => import('./modules/failures/failures.module').then(m => m.FailuresModule),
        canActivate: [DefectsGuard]
      },
      {
        path: DATA_URL,
        loadChildren: () => import('./modules/data/data.module').then(m => m.DataModule),
        canActivate: [DataGuard],
      },
      {
        path: SETTINGS_URL,
        loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
        canActivate: [AdminGuard]
      },
      {
        path: GO_URL,
        loadChildren: () => import('./modules/go/go.module').then(m => m.GoModule)
      },
      {
        path: REPORTS_URL,
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [ReportsGuard]
      },
    ]
  },
  {
    path: UNAUTHORIZED_URL,
    component: UnauthorizedPageComponent
  },
  {
    path: "**",
    redirectTo: '/'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
